import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Users, FileText, CheckSquare, Landmark, Euro } from "lucide-react";
import api from "@/lib/api";

export default function CommandBar({ open, setOpen }) {
  const [results, setResults] = useState({ clients: [], publications: [], tasks: [], invoices: [], quotes: [] });
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => {
      api.get(`/search?q=${encodeURIComponent(q)}`).then((r) => setResults(r.data)).catch(() => {});
    }, 200);
    return () => clearTimeout(t);
  }, [q, open]);

  const go = (path) => { setOpen(false); setQ(""); navigate(path); };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="p-0 overflow-hidden max-w-lg" data-testid="command-bar" aria-describedby={undefined}>
        <DialogTitle className="sr-only">Recherche</DialogTitle>
        <Command shouldFilter={false}>
          <CommandInput placeholder="Rechercher un client, une publication, une tâche, un n° de facture ou devis…" value={q} onValueChange={setQ} data-testid="command-input" />
          <CommandList>
            <CommandEmpty>Aucun résultat.</CommandEmpty>
            {results.clients.length > 0 && (
              <CommandGroup heading="Clients">
                {results.clients.map((c) => (
                  <CommandItem key={c.id} data-testid={`cmd-client-${c.id}`} onSelect={() => go(`/clients/${c.id}`)}>
                    <Users className="w-4 h-4 mr-2 text-neutral-400" /> {c.name}
                  </CommandItem>
                ))}
              </CommandGroup>
            )}
            {results.publications.length > 0 && (
              <CommandGroup heading="Publications">
                {results.publications.map((p) => (
                  <CommandItem key={p.id} data-testid={`cmd-pub-${p.id}`} onSelect={() => go(`/publications/${p.id}`)}>
                    <FileText className="w-4 h-4 mr-2 text-neutral-400" /> {p.title}
                  </CommandItem>
                ))}
              </CommandGroup>
            )}
            {results.tasks.length > 0 && (
              <CommandGroup heading="Tâches">
                {results.tasks.map((t) => (
                  <CommandItem key={t.id} data-testid={`cmd-task-${t.id}`} onSelect={() => go("/taches")}>
                    <CheckSquare className="w-4 h-4 mr-2 text-neutral-400" /> {t.title}
                  </CommandItem>
                ))}
              </CommandGroup>
            )}
            {results.invoices?.length > 0 && (
              <CommandGroup heading="Factures">
                {results.invoices.map((i) => (
                  <CommandItem key={i.id} data-testid={`cmd-invoice-${i.id}`} onSelect={() => go(`/comptabilite?invoice=${i.id}`)}>
                    <Landmark className="w-4 h-4 mr-2 text-neutral-400" /> Facture {i.number} — {i.client_name}
                  </CommandItem>
                ))}
              </CommandGroup>
            )}
            {results.quotes?.length > 0 && (
              <CommandGroup heading="Devis">
                {results.quotes.map((d) => (
                  <CommandItem key={d.id} data-testid={`cmd-quote-${d.id}`} onSelect={() => go("/comptabilite?tab=devis")}>
                    <Euro className="w-4 h-4 mr-2 text-neutral-400" /> Devis N° {d.number} — {d.client_name}
                  </CommandItem>
                ))}
              </CommandGroup>
            )}
          </CommandList>
        </Command>
      </DialogContent>
    </Dialog>
  );
}
